<template>
  <v-card flat class="mt-6">
    
    <v-dialog v-model="dialog" max-width="600px">
      <AdminProfessionsDetail :profession="profession" @close="close" @save="save"></AdminProfessionsDetail>
    </v-dialog>
    <v-data-table :headers="headers" :items="items" class="mx-6">
      
       <!-- action button header -->
      <template v-slot:item.action="{ item }">
        <div style="text-align: right;">
          <v-btn text class="mr-2 px-1" @click="editItem(item)">
            <v-icon>$sl-edit</v-icon>Ändra
          </v-btn>
          <v-btn text class="mr-2 px-1" @click="deleteItem(item)">
            <v-icon>$sl-delete</v-icon>Radera
          </v-btn>
        </div>
      </template>

      <!-- machine profession icon-->
      <template v-slot:item.isMachineProfession="{ item }">
        <v-icon>{{ item.isMachineProfession ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
       
       <!-- Apprenticeship Employment icon-->
      <template v-slot:item.isApprenticeshipEmployment="{ item }">
        <v-icon>{{ item.isApprenticeshipEmployment ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
      
      <!-- Allow Apprentices icon-->
      <template v-slot:item.allowNewApprentices="{ item }">
        <v-icon>{{ item.allowNewApprentices ? "$sl-check-square" : "$sl-uncheck-square" }}</v-icon>
      </template>
    </v-data-table>

    <v-btn absolute bottom right fab @click="newItem">
      <v-icon class="ml-1">$sl-add</v-icon>
    </v-btn>
  </v-card>
</template>

<script>
import API from '@/services/api.js'
import {log} from 'util'
import {RulesMixin} from '@/components/mixins'
import AdminProfessionsDetail from '@/components/CrudTable/professions/AdminProfessionsDetail'

// @group Common
// Styled AdminProfessions component
export default {
  name: 'AdminProfessions',
  components: {AdminProfessionsDetail},
  mixins: [RulesMixin],

  // props: {
  //   fn: {
  //     type: String,
  //     required: true
  //   },
  //   tableTitle: {
  //     type: String,
  //     required: true
  //   },
  //   headersProps: {
  //     type: Array,
  //     default: []
  //   },
  //   dfltItem: {
  //     type: Object,
  //     default: {}
  //   }
  //},
  data: () => ({
    fn: 'Professions',
    tableTitle: 'Yrken',
    headersProps: [
      {text: 'Namn', value: 'name'},
      {text: 'Maskinyrke', value: 'isMachineProfession', align: 'center', sortable: false},
      {text: '', value: 'action', sortable: false}
    ],
    dfltItem: {
      name: {
        value: '',
        label: 'Namn',
        type: 'text',
        required: true
      },
      isMachineProfession: {
        value: false,
        label: 'Maskinyrke',
        type: 'boolean'
      }
    },
    dialog: false,
    headers: [],
    items: [],
    editedItem: {},
    editedIndex: -1,
    item: {},
    profession: {},
    label: ''
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? `Skapa ${this.tableTitle}`
        : `Redigera ${this.tableTitle}`
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
    
  },

  methods: {
    initialize() {
      API['list' + [this.fn]]()
        .then(response => {
          this.items = response.data
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },

    newItem(item) {
      this.editedIndex = -1
      //- Set to "model"
      this.profession={}
      this.dialog = true
    },

    editItem(item) {
      API.getProfession(item.id)
        .then(response => {    
          this.profession = response.data
          if (this.profession.newInstructionsAt)
            this.profession.newInstructionsAt = this.$options.filters.date(this.profession.newInstructionsAt)
        })
        .catch(error => {
          this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
          console.log('There was an error:', error)
        })
      this.dialog = true
    },

    async deleteItem(item) {
      const res = await this.$dialog.confirm({
        text: 'Radering av yrke går inte att ångra.',
        title: 'Vill du radera detta yrke?',
        actions: [
          {text: 'Avbryt', key: false, icon: '$sl-cancel'},
          {text: 'Radera', key: true, icon: '$sl-delete', outlined: true}
        ]
      })

      if (res === true) {
        const index = this.items.indexOf(item)
        API.deleteProfessions(item.id)
          .then(reponse => {
            this.items.splice(index, 1)
            this.$events.fire('showInfo', 'Yrket raderat.')
          })
          .catch(error => {
            this.$events.fire('showError', 'Ett fel uppstod (' + error.message + '), om detta händer igen v.v. kontakta BYN:s kansli.')
            console.log('There was an error:', error)
          })
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {  
        this.editedIndex = -1
      }, 300)
    },

    save() {
      this.close()
      this.initialize()
    }
  },
  mounted() {
    this.headers = this.headersProps
  }
}
</script>

<style scoped>
</style>